import { persistLeftDrawerWidth } from '@app/shared/api/user'

import { createDrawerWidthLayout } from './drawer-width-layout'

// Bounds must match UserPreferencesContract::LEFT_DRAWER_WIDTH_RANGE and the
// clamp() in two-drawer-layout-new.scss.
export const LEFT_DRAWER_MIN_WIDTH_PX = 200
export const LEFT_DRAWER_MAX_WIDTH_PX = 480

export const leftDrawerLayout = createDrawerWidthLayout({
  drawerId: 'left-drawer',
  cssVariable: '--left-drawer-user-width',
  minWidthPx: LEFT_DRAWER_MIN_WIDTH_PX,
  maxWidthPx: LEFT_DRAWER_MAX_WIDTH_PX,
  anchoredEdge: 'left',
  persist: (px) => persistLeftDrawerWidth(px),
})

export const {
  setWidthPx,
  readWidthPx,
  beginDragMeasurement,
  requestedWidthPx,
  maxAvailableWidthPx,
} = leftDrawerLayout
